import anime from 'animejs';

export function aniFadeIn(aElement, aDuration, aDelay = 0) {
  return anime({
    targets: aElement,
    duration: aDuration,
    delay: aDelay,
    easing: 'easeInOutSine',
    opacity: [0, 1],
  });
}

export function aniFadeOut(aElement, aDuration, aDelay = 0) {
  return anime({
    targets: aElement,
    duration: aDuration,
    delay: aDelay,
    easing: 'easeInOutSine',
    opacity: [1, 0],
  });
}

export function aniFlipIn(aElement, aDuration, aDelay = 0) {
  return anime({
    targets: aElement,
    duration: aDuration,
    delay: aDelay,
    easing: 'easeInOutSine',
    rotateX: [90, 0],
  });
}

export function aniFlipOut(aElement, aDuration, aDelay = 0) {
  return anime({
    targets: aElement,
    duration: aDuration,
    delay: aDelay,
    easing: 'easeInOutSine',
    rotateX: [0, 90],
  });
}

export function aniSlideYIn(aElement, aValue, aDuration, aDelay = 0) {
  return anime({
    targets: aElement,
    duration: aDuration,
    delay: aDelay,
    easing: 'easeInOutSine',
    translateY: [aValue, 0],
    opacity: [0, 1],
  });
}

export function aniSlideYOut(aElement, aValue, aDuration, aDelay = 0) {
  return anime({
    targets: aElement,
    duration: aDuration,
    delay: aDelay,
    easing: 'easeInOutSine',
    translateY: [0, aValue],
    opacity: [1, 0],
  });
}
